import BlogTwentyNineContainer from "./container/BlogTwentyNineContainer";
export default BlogTwentyNineContainer;
